import * as Bowser from "bowser";
import { ScreenShareEvent, ReadyState, BrowserName } from "globals/enums";

type DisplayMediaTrackSettings = MediaTrackSettings & { displaySurface?: string };

export const isTsbBrowser = () => {
  return (
    window.navigator.userAgent.includes("Proview-SB") ||
    window.navigator.userAgent.includes("TalviewBrowser")
  );
};

// const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

export const getSharedScreenEvent = (videoTrackStream: MediaStreamTrack[], userBrowser: string) => {
  const mediaStreamTrack = videoTrackStream && videoTrackStream.length ? videoTrackStream[0] : null;

  if (!mediaStreamTrack) {
    return ScreenShareEvent.NotShared;
  }

  const settings = (mediaStreamTrack.getSettings?.() || {}) as DisplayMediaTrackSettings;
  const displaySurface = settings.displaySurface?.toLowerCase();

  if (displaySurface) {
    if (["monitor", "screen", "desktop"].includes(displaySurface)) {
      return ScreenShareEvent.EntireScreenShare;
    }
    if (["window", "application"].includes(displaySurface)) {
      return ScreenShareEvent.WindowScreenShare;
    }
    if (["browser", "tab"].includes(displaySurface)) {
      return ScreenShareEvent.TabScreenShare;
    }
  }

  let sharedScreen = "";
  if (mediaStreamTrack.readyState === ReadyState.Live) {
    sharedScreen = mediaStreamTrack.label?.toLowerCase() ?? "";
  }

  const entireScreenValues = [
    ScreenShareEvent.PrimaryMonitor.toLowerCase(),
    ScreenShareEvent.Monitor,
    ScreenShareEvent.Screen,
    "display",
    "retina",
    "lcd"
  ];

  if (sharedScreen.includes("browser") || sharedScreen.includes("tab")) {
    return ScreenShareEvent.TabScreenShare;
  }

  if (
    entireScreenValues.some((value) => sharedScreen.includes(value)) ||
    isTsbBrowser() ||
    (userBrowser === BrowserName.Firefox && mediaStreamTrack.label === "")
  ) {
    return ScreenShareEvent.EntireScreenShare;
  }

  if (sharedScreen.includes("window") || sharedScreen.includes("application")) {
    return ScreenShareEvent.WindowScreenShare;
  }

  return ScreenShareEvent.NotShared;
};

export const getUserBrowser = () => {
  const browser = Bowser.getParser(window.navigator.userAgent);
  return browser.getBrowser().name.toLocaleLowerCase() as BrowserName;
};

const supportedBrowsers = [BrowserName.Chrome, BrowserName.Edge, BrowserName.Firefox, BrowserName.QQBrowser, BrowserName.Safari];
export const isSupportedBrowser = () => {
  return supportedBrowsers.includes(getUserBrowser()) || isTsbBrowser();
};

export const detectMob = () => {
  const toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i
  ];

  return toMatch.some((toMatchItem) => {
    return navigator.userAgent.match(toMatchItem);
  });
};
